export default "__VITE_ASSET__BVBfdeJ2__"